import { ReactElement } from "react";
import SurveySummaryEntry from "../../survey-results/survey-summary-entry.component";

export interface ResultsQuestionSummaryProps {
  readonly questionId: string;
  readonly summaries: string[];
  readonly surveyId: string;
}
const ResultsQuestionSummary = ({ summaries, surveyId }: ResultsQuestionSummaryProps): ReactElement => {
  return (
    <div className="flex flex-col w-full border-t-gray-light-10 border-t px-6 pt-6">
      <SurveySummaryEntry
        surveyId={surveyId}
        summaries={summaries}
      />
    </div>
  );
};

export default ResultsQuestionSummary;
